export const AllowedReadFormatTypes = [
  'excelReader',
  'textReader',
  'xmlReader',
  'delimitedReader',
  'jsonReader',
];

export const AllowedWriteFormatTypes = [
  'excelWriter',
  'textWriter',
  'xmlWriter',
  'delimitedWriter',
];

export const AllowedFormatTypes = [...AllowedReadFormatTypes, ...AllowedWriteFormatTypes];
